import {
  apiActionBuilder,
  apiRequestPayloadBuilder,
  ApiRequestPayloadBuilderOptions,
  ApiSuccessAction,
  HttpMethod,
} from "../api-builder";
import { ILimitation } from "../../../slices/merchant/interfaces";

export interface IUsage {
  limitation: ILimitation;
  currentValue: number;
}

export interface GetMerchantsUsagesByMerchantIdParams {
  merchantId: string;
}

export interface GetMerchantsUsagesByMerchantIdResponseData {
  usages: IUsage[];
}

export default apiActionBuilder<
  GetMerchantsUsagesByMerchantIdParams,
  ApiSuccessAction<GetMerchantsUsagesByMerchantIdResponseData>
>(
  "apis/merchants/{merchantId}/usages/get",
  (
    params: GetMerchantsUsagesByMerchantIdParams,
    options?: ApiRequestPayloadBuilderOptions,
  ) => ({
    payload: apiRequestPayloadBuilder(
      {
        path: `/merchants/${params.merchantId}/usages`,
        method: HttpMethod.GET,
      },
      options,
      params,
    ),
  }),
);
